import { mapState } from "vuex";
import RevenueEvolutionCandle from "@/components/brand_portfolio/RevenueEvolutionCandle";
import AppIcon from "@/components/AppIcon";
import CurrencyValue from "@/components/tableElements/CurrencyValue.vue";
import PercentageValue from "@/components/tableElements/PercentageValue.vue";
import AppPopover from "@/components/AppPopover";
import RevenueEvolutionGraph from "@/components/brand_portfolio/RevenueEvolutionGraph";
export default {
  name: "RevenueEvolutionVsPrevPeriod",
  components: {
    RevenueEvolutionCandle,
    AppIcon,
    CurrencyValue,
    AppPopover,
    RevenueEvolutionGraph,
    PercentageValue
  },
  props: {
    revenueData: {
      type: Array,
      default: []
    },
    periodLength: {
      type: Number,
      default: 14
    },
    selected_period: {
      type: String,
      default: "14 days"
    },
    workspace_id: {
      type: String,
      default: ""
    },
    seller_id: {
      type: String,
      default: ""
    },
    hovering_workspace_id: {
      type: String,
      default: ""
    },
    hovering_seller_id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hovering_index: -1,
      defaultData: {
        label: null,
        evol_value: 0,
        kpi_value: 0
      }
    };
  },
  computed: {
    ...mapState({}),
    computedEvolution() {
      return this.revenueData[0]?.revenue_evol_vs_previous_period > 0 ? "green" : this.revenueData[0]?.revenue_evol_vs_previous_period < 0 ? "red" : "gray";
    },
    evolution_content_uid() {
      return crypto.randomUUID();
    }
  },
  methods: {
    hoveringCandle(index) {
      this.hovering_index = index;
    }
  }
};